/* eslint-disable react/jsx-props-no-spreading -- react-hook-form Controller `field` */
import { Stack, Typography } from '@mui/material';
import { FormStepComponentProps, SIMDocumentTypeAttachmentOption, TextField } from 'common';
import { Controller } from 'react-hook-form';
import { PostSignupFormSchema } from '../schemas';
import { SimAttachmentsDropzone } from '../SimAttachmentsDropzone';
import { LockedFormNotice, LockedFormStatus } from '../LockedFormNotice';

type Props = FormStepComponentProps<typeof PostSignupFormSchema> & {
    attachmentOption: SIMDocumentTypeAttachmentOption;
    files: File[];
    onFilesChange: (files: File[]) => void;
    hasError: boolean;
    lockedStatus: LockedFormStatus | null;
};

export function CertificateOfInsuranceStep({
    control,
    attachmentOption,
    files,
    onFilesChange,
    hasError,
    lockedStatus,
}: Props) {
    return (
        <Stack spacing={3} p={{ xs: 2, sm: 0 }}>
            <Typography variant="subtitle1">Certificate of Insurance</Typography>
            <Typography variant="body2" color="text.secondary">
                Your buyer has requested proof of insurance. Please fill in the fields below.
            </Typography>
            <LockedFormNotice status={lockedStatus} />
            <Controller
                name="certificateOfInsurance.Carrier"
                control={control}
                render={({ field, fieldState }) => (
                    <TextField
                        {...field}
                        label="Carrier"
                        required
                        error={fieldState.invalid}
                        helperText={fieldState.error?.message}
                        testId="coi-carrier"
                    />
                )}
            />
            <Controller
                name="certificateOfInsurance.PolicyNumber"
                control={control}
                render={({ field, fieldState }) => (
                    <TextField
                        {...field}
                        label="Policy Number"
                        required
                        error={fieldState.invalid}
                        helperText={fieldState.error?.message}
                        testId="coi-policy-number"
                    />
                )}
            />
            <SimAttachmentsDropzone
                attachmentOption={attachmentOption}
                files={files}
                onFilesChange={onFilesChange}
                hasError={hasError}
                testId="coi-attachments"
            />
        </Stack>
    );
}
